<div class="glass context-holder">
    <ul class="list-group list-group-flush mb-3">
        <li class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-center"
            (click)="shareCoordinate()">
            <div class="me-2">Copy link to coordinate</div>
            <fa-icon [icon]="iconsService.faIconsRegular.faClipboard"></fa-icon>
        </li>
<!--        <li class="list-group-item list-group-item-action pointer d-flex justify-content-between align-items-center"-->
<!--            (click)="shareObject()">-->
<!--            <div>Copy link to {{ objectType }}</div>-->
<!--            <fa-icon [icon]="iconsService.faIconsRegular.faFileClipboard"></fa-icon>-->
<!--        </li>-->
        <!--        <li class="list-group-item list-group-item-action pointer">A second item</li>-->
        <!--        <li class="list-group-item list-group-item-action pointer">A third item</li>-->
        <!--        <li class="list-group-item list-group-item-action pointer">A fourth item</li>-->
        <!--        <li class="list-group-item list-group-item-action pointer">And a fifth one</li>-->
    </ul>
</div>
